import userInQueIcon from '../../../assets/images/icons/user-booking.svg'; // Adjust the path as necessary
import userQueIcon from '../../../assets/images/icons/user-in-join-queue.svg';
import loading from '../../../assets/images/icons/refreshloader.gif';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

const CalendarLogicDesign = ({
  dateNumber,
  isSelected,
  bookingOnDate,
  currentDateString,
  handleCancelBookingClick,
  handleShowBookingModal,
  handleJoinQueueModal,
  handleLeaveQueueModal,
  fetchButton,
  zoneList,
  selectedZoneName,
  selectedCalendarZoneId,
  handleZoneChange,
  shouldShowFilter, // Boolean to control filter visibility
  filterIcon,       // Imported filter icon image
  creditInfo,       // creditInfo JSX received from parent
  recordsData,
  isPastDate,
  shouldApplyWeekDateClass,
  isForcedDisabled,
  loadingDates,
  getLoadingDateKey,
  fetchWeekData,
  mapAvailableType,
  iconzoneType,
  handleVehicleNotAvailable,
  loadingprocessModal
}) => {
  const isDateContentActive = !isPastDate && !isForcedDisabled;
  const dateClassName = shouldApplyWeekDateClass ? 'ctm-week-date' : 'ctm-date';
  const dateDiv = isDateContentActive && dateNumber
    ? (<div className={dateClassName}>{dateNumber}</div>)
    : (<div className='past-date'>{dateNumber}</div>);

  const loadingKey = getLoadingDateKey
    ? getLoadingDateKey(selectedCalendarZoneId, currentDateString)
    : currentDateString;
  const isLoading = loadingDates?.includes(loadingKey);
  const history = useHistory();
  function GotoMapClick(zoneId, bookingDateStr) {
        console.log("GotoMapClick clicked");

        if (mapAvailableType === 2 || mapAvailableType === 3) {

            history.push("/map", {
                selectedZoneId: zoneId,
                selectedDate: bookingDateStr
            });

        } else {
            // history.push("/no-map-available", { zoneId });
            
        }
    }
  const {t} = useTranslation()

  let bookingIndicatorJSX = null;

  // if (isLoading) {
  //   // show loading overlay for this date
  //   bookingIndicatorJSX = (
  //     <div className="ctm-refresh-button">
  //       <span style={{ color: 'green', fontWeight: 'bold' }}>
  //         <div id='cal-preloader'>
  //           <img src={loading} alt="Loading..." />
  //         </div>
  //       </span>
  //     </div>
  //   );
  // }
  if (isLoading) {
  bookingIndicatorJSX = (
    <div
      className="ctm-refresh-button"
      style={{
        position: 'absolute',
        inset: 0,           // Fills the entire cell
        zIndex: 2,          // Sits on top of everything
        cursor: isPastDate ? 'default' : 'pointer'
      }}
      // style={{ position: "relative", cursor: "pointer" }}
      onClick={(e) => {
        e.stopPropagation();
        loadingprocessModal()
      }}
    >
      <span style={{ color: 'green', fontWeight: 'bold' }}>
        <div id='cal-preloader'>
          <img src={loading} alt="Loading..." />
        </div>
      </span>
    </div>
  );
}
   else if (isForcedDisabled) {
    bookingIndicatorJSX = (
      <div className=''>
        <div className='occupied-room-space-not-available'>
          <div
            style={{
              // position: 'absolute',
              // top: '3px',
              // right: '3px',
              // width: '38px',
              // height: '38px',
              // borderRadius: '100%',
              // backgroundColor: '#D2D2D2',
              // backgroundRepeat: 'repeat',
              // backgroundPosition: 'center',
              // backgroundaSize: 'contain',
              // zIndex: 0,
            }}
          />
        </div>
      </div>
    );
}
   else if (isDateContentActive && bookingOnDate) {
    // User want to join in Booking Queue
    // if (recordsData.QueueUser == 1 && bookingOnDate.DisplayQueue == 1) {
    //   bookingIndicatorJSX = (
    //     <div className='occupied-code'>
    //       <div
    //         style={{
    //           position: 'absolute',
    //           bottom: '0px',
    //           left: '8px',
    //           width: '38px',
    //           height: '38px',
    //           borderRadius: '100%',
    //           backgroundRepeat: 'repeat',
    //           backgroundPosition: 'center',
    //           backgroundaSize: 'contain',
    //           zIndex: 1,
    //         }}
    //         onClick={(event) => {
    //           event.stopPropagation();
    //           handleJoinQueueModal(currentDateString);
    //         }}
    //         disabled={isPastDate}
    //       >
    //         <div className="joinqueue-icon">
    //         <img src={userQueIcon} alt="Join Queue" />
    //         </div>
    //       </div>
    //     </div>
    //   );
    // }
    if (recordsData.QueueUser == 1 && bookingOnDate.DisplayQueue == 1) {
      const showGreenCircle = bookingOnDate.DeskAvailable == 1 || bookingOnDate.HourlySpotAvailable == 1 || bookingOnDate.MeetingRoomAvailable == 1;
      bookingIndicatorJSX = (
        <div className='occupied-code' style={{ position: 'absolute', inset: 0 }}>
          {showGreenCircle && (
                <div
                    style={{
                        position: 'absolute',
                        top: '3px',
                        right: '3px',
                        width: '38px',
                        height: '38px',
                        borderRadius: '100%',
                        backgroundColor: '#17847787',
                        zIndex: 1,
                    }}
                />
            )}
          {showGreenCircle && (
                <div
                    style={{
                        position: 'absolute',
                        top: '3px',
                        right: '3px',
                        width: '38px',
                        height: '38px',
                        borderRadius: '100%',
                        backgroundColor: '#17847787',
                        zIndex: 1,
                    }}
                />
            )}

          {/* 🟢 1. YOUR ORIGINAL DESIGN (Visual Only) */}
          <div
            style={{
              position: 'absolute',
              top: '0px',
              left: '8px',
              width: '38px',
              height: '38px',
              borderRadius: '100%',
              backgroundRepeat: 'repeat',
              backgroundPosition: 'center',
              backgroundSize: 'contain',
              zIndex: 1, // Visual stays underneath the click shield
            }}
          >
            <div className="joinqueue-icon">
              <img src={userQueIcon} alt="Join Queue" />
            </div>
          </div>          

{
  bookingOnDate.SpotId > 0 && (
  
          <div
            style={{
              position: 'absolute',
              inset: 0,           // Fills the entire cell
              zIndex: 2,          // Sits on top of everything
              cursor: isPastDate ? 'default' : 'pointer'
            }}>

            <div className={`occupied-room ${isPastDate ? 'disabled-booking' : ''}`}>
              <div className="occupied-details">
                <div className="occupied-code">{bookingOnDate.SpotName}</div>
                <div className="occupied-credit">{bookingOnDate.TotalBookingCount}</div>
              </div>
            </div>
          </div>
          )
}

          {/* 👆 2. TRANSPARENT CLICK OVERLAY (Covers the Entire Cell) */}
          <div
            style={{
              position: 'absolute',
              inset: 0, // Stretches to fill the whole block
              width: '100%',
              height: '100%',
              backgroundColor: 'transparent', // Invisible
              zIndex: 2, // Sits on top to capture clicks
              cursor: isPastDate ? 'not-allowed' : 'pointer',
            }}
            onClick={(event) => {
              event.stopPropagation();
              if (!isPastDate) {
                handleJoinQueueModal(currentDateString);
              }
            }}
          />
        </div>
      );
    }





    //User in Booking Queue
    // else if (recordsData.ShowWaitlistPosition == 1 && (recordsData.QueueUser == 1 && bookingOnDate.JoinedQueue == 1)) {
    //   bookingIndicatorJSX = (
    //     <div className='occupied-code'>
    //       <div
    //         style={{
    //           position: 'absolute',
    //           bottom: '0px',
    //           left: '8px',
    //           width: '38px',
    //           height: '38px',
    //           borderRadius: '100%',
    //           backgroundRepeat: 'repeat',
    //           backgroundPosition: 'center',
    //           backgroundaSize: 'contain',
    //           zIndex: 1,
    //         }}
    //         onClick={(event) => {
    //           event.stopPropagation();
    //           handleLeaveQueueModal(currentDateString);
    //         }}
    //         disabled={isPastDate}
    //       >
    //         <div className="joinqueue-icon">

    //         <img src={userInQueIcon} alt="Leave Queue" /> 
    //         <a style={{ color: "var(--color-theme-green)" }}>

    //             {bookingOnDate?.QueuePosition > 0 && (
    //               <a style={{ color: "var(--color-theme-green)" }}>
    //                 {bookingOnDate.QueuePosition}
    //               </a>
    //             )}

    //           {/* +{bookingOnDate.QueuePosition} */}
    //           </a>
    //         </div>

    //       </div>
    //     </div>
    //   );
    // }

    // else if (recordsData.ShowWaitlistPosition == 0 && (recordsData.QueueUser == 1 && bookingOnDate.JoinedQueue == 1)) {
    //   bookingIndicatorJSX = (
    //     <div className='occupied-code'>
    //       <div
    //         style={{
    //           position: 'absolute',
    //           bottom: '0px',
    //           left: '8px',
    //           width: '38px',
    //           height: '38px',
    //           borderRadius: '100%',
    //           backgroundRepeat: 'repeat',
    //           backgroundPosition: 'center',
    //           backgroundaSize: 'contain',
    //           zIndex: 1,
    //         }}
    //         onClick={(event) => {
    //           event.stopPropagation();
    //           handleLeaveQueueModal(currentDateString);
    //         }}
    //         disabled={isPastDate}
    //       >
    //         <div className="joinqueue-icon">

    //         <a style={{ color: "var(--color-theme-green)" }}>

    //             {bookingOnDate?.EmployeeQueueCount > 0 && (
    //               <a style={{ color: "var(--color-theme-green)" }}>
    //                 +{bookingOnDate.EmployeeQueueCount}
    //               </a>
    //             )}

    //           {/* +{bookingOnDate.QueuePosition} */}
    //           </a>
    //         <img src={userInQueIcon} alt="Leave Queue" /> 
    //         </div>

    //       </div>
    //     </div>
    //   );
    // }
    else if (recordsData.ShowWaitlistPosition == 1 && (recordsData.QueueUser == 1 && bookingOnDate.JoinedQueue == 1)) {
      const showGreenCircle = bookingOnDate.DeskAvailable == 1 || bookingOnDate.HourlySpotAvailable == 1 || bookingOnDate.MeetingRoomAvailable == 1;
      bookingIndicatorJSX = (
        <div className='occupied-code' style={{ position: 'absolute', inset: 0 }}>
          {showGreenCircle && (
                <div
                    style={{
                        position: 'absolute',
                        top: '3px',
                        right: '3px',
                        width: '38px',
                        height: '38px',
                        borderRadius: '100%',
                        backgroundColor: '#17847787',
                        zIndex: 1,
                    }}
                />
            )}

          {/* 🟢 1. YOUR ORIGINAL DESIGN (Visual Only) */}
          <div
            style={{
              position: 'absolute',
              top: '0px',
              left: '8px',
              width: '38px',
              height: '38px',
              borderRadius: '100%',
              backgroundRepeat: 'repeat',
              backgroundPosition: 'center',
              backgroundSize: 'contain',
              zIndex: 1, // Visual stays underneath the click shield
            }}
          >
            <div className="joinqueue-icon">
              <img src={userInQueIcon} alt="Leave Queue" />
              <a style={{ color: "var(--color-theme-green)" }}>
                {bookingOnDate?.QueuePosition > 0 && (
                  <a style={{ color: "var(--color-theme-green)" }}>
                    {bookingOnDate.QueuePosition}
                  </a>
                )}
              </a>
            </div>
              
            </div>
            {bookingOnDate.SpotId > 0 &&
          <div
            style={{
              position: 'absolute',
              inset: 0,           // Fills the entire cell
              zIndex: 2,          // Sits on top of everything
              cursor: isPastDate ? 'default' : 'pointer'
            }}>

            <div className={`occupied-room ${isPastDate ? 'disabled-booking' : ''}`}>
                <div className="occupied-details">
                    <div className="occupied-code">{bookingOnDate.SpotName}</div>
                    <div className="occupied-credit">{bookingOnDate.TotalBookingCount}</div>
                </div>
            </div>
          </div>
          }

          {/* 👆 2. TRANSPARENT CLICK OVERLAY (Covers the Entire Cell) */}
          <div
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'transparent',
              zIndex: 2, // Sits on top to capture clicks
              cursor: isPastDate ? 'not-allowed' : 'pointer',
            }}
            onClick={(event) => {
              event.stopPropagation();
              if (!isPastDate) {
                handleLeaveQueueModal(currentDateString);
              }
            }}
          />
        </div>
      );
    }
    else if (recordsData.ShowWaitlistPosition == 0 && (recordsData.QueueUser == 1 && bookingOnDate.JoinedQueue == 1)) {
      const showGreenCircle = bookingOnDate.DeskAvailable == 1 || bookingOnDate.HourlySpotAvailable == 1 || bookingOnDate.MeetingRoomAvailable == 1;
      bookingIndicatorJSX = (
        <div className='occupied-code' style={{ position: 'absolute', inset: 0 }}>
          {showGreenCircle && (
                <div
                    style={{
                        position: 'absolute',
                        top: '3px',
                        right: '3px',
                        width: '38px',
                        height: '38px',
                        borderRadius: '100%',
                        backgroundColor: '#17847787',
                        zIndex: 1,
                    }}
                />
            )}

          <div
            style={{
              position: 'absolute',
              top: '0px',
              left: '8px',
              width: '38px',
              height: '38px',
              borderRadius: '100%',
              backgroundRepeat: 'repeat',
              backgroundPosition: 'center',
              backgroundSize: 'contain',
              zIndex: 1,
            }}
          >
            <div className="joinqueue-icon">
              <a style={{ color: "var(--color-theme-green)" }}>
                {bookingOnDate?.EmployeeQueueCount > 0 && (
                  <a style={{ color: "var(--color-theme-green)" }}>
                    +{bookingOnDate.EmployeeQueueCount}
                  </a>
                )}
              </a>
              <img src={userInQueIcon} alt="Leave Queue" />
            </div>
          </div>

          {bookingOnDate.SpotId !== -1 &&
          <div
            style={{
              position: 'absolute',
              inset: 0,           // Fills the entire cell
              zIndex: 2,          // Sits on top of everything
              cursor: isPastDate ? 'default' : 'pointer'
            }}>

            <div className={`occupied-room ${isPastDate ? 'disabled-booking' : ''}`}>
              <div className="occupied-details">
                <div className="occupied-code">{bookingOnDate.SpotName}</div>
                <div className="occupied-credit">{bookingOnDate.TotalBookingCount}</div>
              </div>
            </div>
          </div>
          }
          

          {/*TRANSPARENT CLICK OVERLAY (Covers the Entire Cell) */}
          <div
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'transparent',
              zIndex: 2,
              cursor: isPastDate ? 'not-allowed' : 'pointer',
            }}
            onClick={(event) => {
              event.stopPropagation();
              if (!isPastDate) {
                handleLeaveQueueModal(currentDateString);
              }
            }}
          />
        </div>
      );
    }




    // Booked Spot
    // else if (bookingOnDate.SpotId !== 0 && bookingOnDate.SpotName !== '0') {
    // const showGreenCircle = bookingOnDate.DeskAvailable == 1;
    //   bookingIndicatorJSX = (
    //     <div className="date-active" style={{ position: 'absolute', inset: 0 }}>
    //       {showGreenCircle && (
    //     <div
    //       style={{
    //         position: 'absolute',
    //         top: '3px',
    //         right: '3px',
    //         width: '38px',
    //         height: '38px',
    //         borderRadius: '100%',
    //         backgroundColor: '#17847787',
    //         backgroundRepeat: 'no-repeat',
    //         backgroundPosition: 'center',
    //         backgroundSize: 'contain',
    //         zIndex: 1,
    //       }}
    //     />
    //   )}
    //     <div
    //       className={`occupied-room ${isPastDate ? 'disabled-booking' : ''}`}
    //       onClick={(event) => {
    //         event.stopPropagation();
    //         if (!isPastDate) {
    //           handleCancelBookingClick(currentDateString);
    //         }
    //       }}
    //     >
    //       <div className="occupied-details">
    //         <div className="occupied-code">{bookingOnDate.SpotName}</div>
    //         <div className="occupied-credit">{bookingOnDate.TotalBookingCount}</div>
    //       </div>
    //     </div>
    //     </div>
    //   );
    // }
    else if (bookingOnDate.SpotId > 0
      //  && bookingOnDate.SpotName !== '0'
      ) {
    const showGreenCircle = bookingOnDate.DeskAvailable == 1 || bookingOnDate.HourlySpotAvailable == 1 || bookingOnDate.MeetingRoomAvailable == 1;
    const hasCancelableDeskBooking =
      bookingOnDate.DeskCount === 1 ||
      bookingOnDate.HourlyBookingCount !== 0;
    
    bookingIndicatorJSX = (
        <div className="date-active" style={{ position: 'absolute', inset: 0 }}>
            {showGreenCircle && (
                <div
                    style={{
                        position: 'absolute',
                        top: '3px',
                        right: '3px',
                        width: '38px',
                        height: '38px',
                        borderRadius: '100%',
                        backgroundColor: '#17847787',
                        zIndex: 1,
                    }}
                />
            )}

            {/* 🎯 THE FIX: Full Cell Clickable Layer */}
            <div
                style={{
                    position: 'absolute',
                    inset: 0,           // Fills the entire cell
                    zIndex: 2,          // Sits on top of everything
                    cursor: isPastDate ? 'default' : 'pointer'
                }}
                onClick={(event) => {
                    event.stopPropagation();
                    if (!isPastDate) {
                        if (hasCancelableDeskBooking) {
                          handleCancelBookingClick(currentDateString);
                        } else {
                          handleShowBookingModal(currentDateString);
                        }
                    }
                }}
            />

            {/* UI Visuals (Non-clickable now, handled by overlay above) */}
            <div className={`occupied-room ${isPastDate ? 'disabled-booking' : ''}`}>
                <div className="occupied-details">
                    <div className="occupied-code">{bookingOnDate.SpotName}</div>
                    <div className="occupied-credit">{bookingOnDate.TotalBookingCount}</div>
                </div>
            </div>
        </div>
    );
}
    

    //Holiday Spot
    else if (bookingOnDate.CurrentMonth == 0 || bookingOnDate.DayNotAvailable == 1) {
      bookingIndicatorJSX = (
        <div className='ctm-fc-holiday ctm-date-holiday'>
          <div className='occupied-room-space-not-available'>
            <div
              style={{
                // position: 'absolute',
                // top: '3px',
                // right: '3px',
                // width: '38px',
                // height: '38px',
                // borderRadius: '100%',
                // backgroundColor: '#D2D2D2',
                // backgroundRepeat: 'repeat',
                // backgroundPosition: 'center',
                // backgroundaSize: 'contain',
                // zIndex: 0,
              }}
            />
          </div>
        </div>
      );
    }

    //Space not available
    // else if (bookingOnDate.SpotAvailable == 0 || bookingOnDate.IsBookingBlocked == 1 || bookingOnDate.CurrentMonth == 0) {
    //   bookingIndicatorJSX = (
    //     <div>
    //       <div className='occupied-room-space-not-available'>
    //         <div
    //           style={{
    //             position: 'absolute',
    //             top: '3px',
    //             right: '3px',
    //             width: '38px',
    //             height: '38px',
    //             borderRadius: '100%',
    //             backgroundColor: '#D2D2D2',
    //             backgroundRepeat: 'repeat',
    //             backgroundPosition: 'center',
    //             backgroundaSize: 'contain',
    //             zIndex: 0,
    //           }}
    //         />
    //       </div>
    //     </div>
    //   );
    // }

    // Combine all "Not Available" scenarios into one block //No Vehicle & //No Space Available
else if (
  bookingOnDate.SpotAvailable == 0 ||
  bookingOnDate.IsBookingBlocked == 1 ||
  bookingOnDate.CurrentMonth == 0 ||
  (iconzoneType == 1 && bookingOnDate.EmployeeVehicleType.length === 0)
) {
  bookingIndicatorJSX = (
    <div className='occupied-room-space-not-available' style={{ position: 'absolute', inset: 0 }}>

      {/* Visual Gray Circle (Shared by both conditions) */}
      <div
        style={{
          position: 'absolute',
          top: '3px',
          right: '3px',
          width: '38px',
          height: '38px',
          borderRadius: '100%',
          backgroundColor: '#D2D2D2',
          zIndex: 0,
        }}
      />

      {/* Click Overlay with Internal Logic Selection */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'transparent',
          zIndex: 2,
          cursor: 'pointer',
        }}
        onClick={(event) => {
          event.stopPropagation();

          // DECISION LOGIC:
          // If it's a vehicle zone AND the array is empty, show the vehicle popup
          const isPrimaryVehicleAbsent = recordsData?.Redirect == "AddPrimaryVehicle"
          if (iconzoneType == 1 &&  isPrimaryVehicleAbsent
            // bookingOnDate.EmployeeVehicleType.length === 0
          ) {
            handleVehicleNotAvailable();
            console.log("Showing popup: No vehicles available.");
          } 
          // Otherwise, proceed to the Map for other "Not Available" reasons
          else {
            GotoMapClick(selectedCalendarZoneId, currentDateString);
          }
        }}
      />
    </div>
  );
}
//     else if (bookingOnDate.SpotAvailable == 0 || bookingOnDate.IsBookingBlocked == 1 || bookingOnDate.CurrentMonth == 0) {
//     bookingIndicatorJSX = (
//         <div className='occupied-room-space-not-available' style={{ position: 'absolute', inset: 0 }}>
            
//             {/* ⚪ 1. YOUR ORIGINAL DESIGN (Visual Gray Circle) */}
//             <div
//                 style={{
//                     position: 'absolute',
//                     top: '3px',
//                     right: '3px',
//                     width: '38px',
//                     height: '38px',
//                     borderRadius: '100%',
//                     backgroundColor: '#D2D2D2',
//                     backgroundRepeat: 'repeat',
//                     backgroundPosition: 'center',
//                     backgroundSize: 'contain',
//                     zIndex: 0, // Sits underneath the click layer
//                 }}
//             />

//             {/* 👆 2. TRANSPARENT CLICK OVERLAY (Covers the Entire Cell) */}
//             <div
//                 style={{
//                     position: 'absolute',
//                     inset: 0,
//                     width: '100%',
//                     height: '100%',
//                     backgroundColor: 'transparent', // Invisible
//                     zIndex: 2, // Sits on top to capture clicks for the whole cell
//                     cursor: 'pointer',
//                 }}
//                 onClick={(event) => {
//                     event.stopPropagation();
//                     GotoMapClick(selectedCalendarZoneId, currentDateString);
//                 }}
//             />
//         </div>
//     );
// }


//  //No Vehicle Available
//     else if (iconzoneType == 1 && bookingOnDate.EmployeeVehicleType.length === 0 && (
//       bookingOnDate.SpotAvailable == 0 ||
//       bookingOnDate.IsBookingBlocked == 1 ||
//       bookingOnDate.CurrentMonth == 0
//     )
//     ) {
//       bookingIndicatorJSX = (
//         <div className='occupied-room-space-not-available' style={{ position: 'absolute', inset: 0 }}>

//           {/* 1. Visual Gray Circle */}
//           <div
//             style={{
//               position: 'absolute',
//               top: '3px',
//               right: '3px',
//               width: '38px',
//               height: '38px',
//               borderRadius: '100%',
//               backgroundColor: '#D2D2D2',
//               zIndex: 0,
//             }}
//           />

//           {/* 2. Click Overlay with Popup Logic */}
//           <div
//             style={{
//               position: 'absolute',
//               inset: 0,
//               width: '100%',
//               height: '100%',
//               backgroundColor: 'transparent',
//               zIndex: 2,
//               cursor: 'pointer',
//             }}
//             onClick={(event) => {
//               event.stopPropagation();

//               // Check if we show the popup or navigate
//               if (bookingOnDate.EmployeeVehicleType.length === 0) {
//                 // 1. Show your Modal/Popup state
//                 handleVehicleNotAvailable();
//                 console.log("Showing popup: No vehicles available.");
//               } else {
//                 // 2. Otherwise, proceed with your existing navigation logic
//                 GotoMapClick(selectedCalendarZoneId, currentDateString);
//               }
//             }}
//           />
//         </div>
//       );
//     }






    //Space available
    // else if (
    //   bookingOnDate.CurrentMonth == 1 ||
    //   bookingOnDate.DeskAvailable == 1 ||
    //   bookingOnDate.MeetingRoomAvailable == 1 ||
    //   bookingOnDate.HourlySpotAvailable == 1
    // ) {
    //   bookingIndicatorJSX = (
    //     <div>
    //       <div className='date-active'>
    //         <div
    //           style={{
    //             position: 'absolute',
    //             top: '3px',
    //             right: '3px',
    //             width: '38px',
    //             height: '38px',
    //             borderRadius: '100%',
    //             backgroundColor: '#1c988a3d',
    //             backgroundRepeat: 'repeat',
    //             backgroundPosition: 'center',
    //             backgroundaSize: 'contain',
    //             zIndex: 1,
    //           }}
    //           onClick={(event) => {
    //             event.stopPropagation();
    //             handleShowBookingModal(currentDateString);
    //           }}
    //           disabled={isPastDate}
    //         />
    //       </div>
    //     </div>
    //   );
    // }
    else if (
      bookingOnDate.CurrentMonth == 1 ||
      bookingOnDate.DeskAvailable == 1 ||
      bookingOnDate.MeetingRoomAvailable == 1 ||
      bookingOnDate.HourlySpotAvailable == 1
    ) {
      bookingIndicatorJSX = (
        <div className="date-active" style={{ position: 'absolute', inset: 0 }}>

          <div
            style={{
              position: 'absolute',
              top: '3px',
              right: '3px',
              width: '38px',
              height: '38px',
              borderRadius: '100%',
              backgroundColor: '#17847787',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: 'contain',
              zIndex: 0, // Visual is underneath the click layer
            }}
          />

          {/* TRANSPARENT CLICK OVERLAY (Covers the Entire Cell) */}
          <div
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'transparent',
              zIndex: 2,
              cursor: isPastDate ? 'not-allowed' : 'pointer',
            }}
            onClick={(event) => {
              event.stopPropagation();
              if (!isPastDate) {
                handleShowBookingModal(currentDateString);
              }
            }}
          />
        </div>
      );
    }


    //Space not available
    else if (
      bookingOnDate.DeskAvailable == 0 ||
      bookingOnDate.MeetingRoomAvailable == 0 ||
      bookingOnDate.HourlySpotAvailable == 0
    ) {
      bookingIndicatorJSX = (
        <div>
          <div className='occupied-room-space-not-available'>
            <div
              style={{
                position: 'absolute',
                top: '3px',
                right: '3px',
                width: '38px',
                height: '38px',
                borderRadius: '100%',
                backgroundColor: '#D2D2D2',
                backgroundRepeat: 'repeat',
                backgroundPosition: 'center',
                backgroundaSize: 'contain',
                zIndex: 0,
              }}
            />
          </div>
        </div>
      );
    } else {
      bookingIndicatorJSX = (
        <div>
          <div className='date-active'>
          </div>
        </div>
      );
    }
  }

  let containerClassName = 'fc-daygrid-day'; // Always include FullCalendar's base class

  // Only apply 'my-selected-day' if it's NOT a past date and it IS selected
  if (isDateContentActive && isSelected) {
    containerClassName += ' my-selected-day';
  }

  return (
    <div className={containerClassName}>
      <div className='date-active'>
        {bookingIndicatorJSX}
      </div>

      <div className={`fade-in ${isSelected ? 'my-selected-day-content' : ''}`}>
        {dateDiv}
        {fetchButton}
        {shouldShowFilter && (
          <div className="filter-elements-container" style={{
            position: 'absolute',
            top: '5px',
            right: '5px',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}>
            <img
              src={filterIcon}
              alt="Filter"
              className="filter-icon"
              style={{
                width: '42px',
                height: 'auto',
                marginLeft: '9px',
                display: 'block'
              }}
            />
            <button
              type="button"
              className="filter-button"
              style={{
                width: '42px',
                marginLeft: '9px',
              }}
            // onClick={() => {
            //   console.log('Filter button clicked within CalendarLogicDesign!');
            // }}
            >
              Filter
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarLogicDesign;
